import { NavLink, Outlet } from 'react-router';
import { useSyncStatus } from '../sync/useSyncStatus';

/** Wskaźnik synchronizacji: offline / niewysłane zmiany / zsynchronizowano. */
export function SyncBadge() {
  const s = useSyncStatus();
  if (!s.online)
    return (
      <span className="shrink-0 whitespace-nowrap rounded-full bg-stone-200 px-2 py-0.5 text-xs text-stone-700 dark:bg-stone-800 dark:text-stone-300">
        {/* Liczba wpisów outboxa ≠ liczba zmian użytkownika, więc bez licznika. */}
        offline{s.pending > 0 ? ' · niewysłane' : ''}
      </span>
    );
  if (s.pending > 0 || s.syncing)
    return (
      <span className="shrink-0 whitespace-nowrap rounded-full bg-amber-100 px-2 py-0.5 text-xs text-amber-800 dark:bg-amber-900/40 dark:text-amber-200">
        synchronizuję…
      </span>
    );
  if (s.error && s.error !== 'unauthorized')
    return isNetworkError(s.error) ? (
      <span className="shrink-0 whitespace-nowrap rounded-full bg-stone-200 px-2 py-0.5 text-xs text-stone-700 dark:bg-stone-800 dark:text-stone-300">
        brak połączenia
      </span>
    ) : (
      <span className="shrink-0 whitespace-nowrap rounded-full bg-red-100 px-2 py-0.5 text-xs text-red-800 dark:bg-red-900/40 dark:text-red-200">
        błąd synchronizacji
      </span>
    );
  return null;
}

/**
 * Żądanie nie doszło do serwera (fetch rzucił TypeError, status 0) — w przeciwieństwie do odpowiedzi 5xx.
 * Komunikaty przeglądarek: Chrome „Failed to fetch”, Firefox „NetworkError…”, Safari „Load failed”.
 */
function isNetworkError(error: string): boolean {
  if (!navigator.onLine) return true;
  if (/HTTP 0\b/.test(error)) return true;
  if (/HTTP \d+/.test(error)) return false;
  return /failed to fetch|networkerror|load failed|network ?request|fetch failed|err_network|internet/i.test(error);
}

const tab = ({ isActive }: { isActive: boolean }) =>
  `flex-1 py-3 text-center text-sm font-medium ${isActive ? 'text-brand-700 dark:text-brand-500' : 'text-stone-500'}`;

/** Układ ekranów poza trybem sklepu: treść + dolna nawigacja (zasięg kciuka). */
export function Layout() {
  return (
    <div className="mx-auto flex min-h-dvh max-w-xl flex-col">
      <Outlet />
    </div>
  );
}

export function BottomNav() {
  return (
    <nav className="safe-bottom sticky bottom-0 flex border-t border-stone-200 bg-white/95 backdrop-blur dark:border-stone-800 dark:bg-stone-900/95">
      <NavLink to="/" end className={tab}>
        Listy
      </NavLink>
      <NavLink to="/new" className={tab}>
        + Nowa
      </NavLink>
      <NavLink to="/stores" className={tab}>
        Sklepy
      </NavLink>
      <NavLink to="/prices" className={tab}>
        Ceny
      </NavLink>
      <NavLink to="/home" className={tab}>
        Dom
      </NavLink>
    </nav>
  );
}
